export default __webpack_public_path__ + "static/media/1028.781c056a.png";